import { __assign, __rest } from "tslib";
import * as React from 'react';
import { StyledInput, StyledLabel, StyledContainer, StyledError, StyledTopContainer, StyledCounter, } from './styles/InputStyles';
import { InputWidth } from './Constants';
var getLength = function (value) {
    if (typeof value === 'string') {
        return value && value.length ? value.length : 0;
    }
    if (typeof value === 'number') {
        return value.toString().length || 0;
    }
    return 0;
};
var Input = React.forwardRef(function (_a, ref) {
    var value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, placeholder = _a.placeholder, _c = _a.width, width = _c === void 0 ? InputWidth.MEDIUM : _c, id = _a.id, label = _a.label, error = _a.error, _d = _a.testId, testId = _d === void 0 ? 'kvika-input' : _d, className = _a.className, maxLength = _a.maxLength, _e = _a.fontFamily, fontFamily = _e === void 0 ? 'AkzidenzGroteskPro, Arial, sans-serif' : _e, props = __rest(_a, ["value", "disabled", "placeholder", "width", "id", "label", "error", "testId", "className", "maxLength", "fontFamily"]);
    var characterCounter = getLength(value);
    return (React.createElement(StyledContainer, { width: width },
        error && (React.createElement(StyledError, { "data-testid": "".concat(testId, "-error"), title: error }, error)),
        React.createElement(StyledInput, __assign({ ref: ref, "data-testid": testId, id: id, width: width, maxLength: maxLength, value: value, disabled: disabled, placeholder: placeholder, className: className, fontFamily: fontFamily }, props)),
        label === undefined && maxLength === undefined ? null : (React.createElement(StyledTopContainer, null,
            label && (React.createElement(StyledLabel, { "data-testid": "".concat(testId, "-label"), htmlFor: id }, label)),
            maxLength && (React.createElement(StyledCounter, { "data-testid": "".concat(testId, "-counter") }, "".concat(characterCounter, "/").concat(maxLength)))))));
});
Input.displayName = 'Input';
export default Input;
//# sourceMappingURL=Input.js.map